var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Markdown, { MarkdownProps } from "./Markdown";
import Text from "./Text";
import React from 'react';
import { variant } from 'styled-system';
import theme from "../styles/theme";
import { styled } from "../utils";
var CaptionText = styled(Text)(variant({
    variants: {
        light: {
            color: 'lighterBlack',
        },
        basic: {
            color: 'lightBlack',
        },
    },
}));
var Caption = function (_a) {
    var align = _a.align, textAlign = _a.textAlign, light = _a.light, children = _a.children, color = _a.color, source = _a.source, props = __rest(_a, ["align", "textAlign", "light", "children", "color", "source"]);
    var colors = theme.colors;
    return (React.createElement(Markdown, { "data-component": "Caption", renderers: {
            paragraph: function (paragraphProps) { return (React.createElement(CaptionText, __assign({ textAlign: textAlign || align, color: color || light ? colors.lighterBlack : colors.lightBlack }, paragraphProps, props))); },
        }, source: source }, children));
};
Caption.defaultProps = {
    align: 'left',
    light: false,
    lineHeight: '1.3',
    letterSpacing: '0.04rem',
    fontSize: 0,
};
export default Caption;
//# sourceMappingURL=Caption.js.map